export default __webpack_public_path__ + "static/media/pdf-file.513d4100.png";